import Swiper from './vendor/swiper/swiper.min.js';

const slider = new Swiper('.swiper-container', {
    speed: 1000,
    centeredSlides: true,
    // coverflowEffect: {
    //     rotate: 10,
    //     stretch: 0,
    //     depth: 50,
    //     modifier: 1,
    //     slideShadows: true,
    // },
    effect: 'fade',
    // fadeEffect: {
    //     crossFade: true
    //   },
    autoplay: {
        delay: 8000
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
});

const smallSlider = new Swiper('.small-swiper-container', {
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
});
